var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAddOutline = function SvgAddOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a.9.9 0 01.9.9v7.2h7.2a.9.9 0 010 1.8l-7.2-.001V20.1a.9.9 0 11-1.8 0V12.9l-7.2.001a.9.9 0 010-1.8h7.2V3.9A.9.9 0 0112 3z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDNDMTIuNDk3MSAzIDEyLjkgMy40MDI5MyAxMi45IDMuODk5OTZMMTIuOSAxMS4xTDIwLjEgMTEuMUMyMC41OTcxIDExLjEgMjEgMTEuNTAzIDIxIDEyQzIxIDEyLjQ5NyAyMC41OTcxIDEyLjkgMjAuMSAxMi45TDEyLjkgMTIuODk5TDEyLjkgMjAuMTAwMUMxMi45IDIwLjU5NzIgMTIuNDk3MSAyMS4wMDAxIDEyIDIxLjAwMDFDMTEuNTAzIDIxLjAwMDEgMTEuMTAwMSAyMC41OTcyIDExLjEwMDEgMjAuMTAwMUwxMS4xIDEyLjg5OUwzLjg5OTk1IDEyLjlDMy40MDI5MiAxMi45IDMgMTIuNDk3IDMgMTJDMyAxMS41MDMgMy40MDI5MiAxMS4xIDMuODk5OTUgMTEuMUwxMS4xIDExLjFMMTEuMTAwMSAzLjg5OTk2QzExLjEwMDEgMy40MDI5MyAxMS41MDMgMyAxMiAzWiIgZmlsbD0iIzAyM0Y4MCIvPgo8L3N2Zz4K";
export { SvgAddOutline as ReactComponent };